import { FC, useState } from 'react';
import { Icon } from '../../../style/Icon';
import {
  ButtonsWrapper,
  DontCreateButton,
  Retry,
  RetryButton,
  RetryButtonWrapper,
  WarningExtended,
  WarningWrapper,
} from './NoteWarning.elements';
import RetryNoteModal from './RetryNoteModal';

type NoteWarningProps = {
  warning?: string;
  showRetryButton: boolean;
  showManualOppButtons: boolean;
  retrySent: boolean;
  crmType?: number;
  onRetryClick: (onRetryClick: boolean) => void;
  retryButtonDisabled: boolean;
  onDontCreateClick: () => void;
  openRetryInfo?: () => void;
};

const Warning = ({ warning }: { warning?: string }): JSX.Element => (
  <WarningExtended size={14} color='#8a6d3b' paddingRight={20}>
    {warning || 'Failed to send a note to the CRM'}
  </WarningExtended>
);

const WarningIcon = (): JSX.Element => (
  <Icon
    type='warning'
    marginTop={4}
    size={18}
    color='#8a6d3b'
    style={{ alignSelf: 'flex-start' }}
  />
);

const NoteWarning: FC<NoteWarningProps> = ({
  warning,
  showRetryButton,
  showManualOppButtons,
  retrySent,
  crmType,
  onRetryClick,
  onDontCreateClick,
  retryButtonDisabled,
  openRetryInfo,
}) => {
  const [notesRetryModalOpen, setNotesRetryModalOpen] = useState<boolean>(false);
  const isVinSolutionNote = crmType === 3;

  const handleRetry = (addMissingData: boolean) => {
    if (retrySent) {
      return;
    }
    if (isVinSolutionNote) {
      setNotesRetryModalOpen(true);
    } else {
      onRetryClick(addMissingData);
    }
  };

  return (
    <WarningWrapper data-testid='note-warning'>
      <WarningIcon />
      <Warning warning={warning} />
      {showRetryButton && (
        <RetryButtonWrapper>
          {Retry(isVinSolutionNote, retrySent, retryButtonDisabled, handleRetry)}
        </RetryButtonWrapper>
      )}
      {showManualOppButtons && (
        <ButtonsWrapper data-testid='opportunity-buttons'>
          <DontCreateButton data-testid='dont-create-opp-button' onClick={onDontCreateClick}>
            {' '}
            Don't Create{' '}
          </DontCreateButton>
          <RetryButton data-testid='create-opp-button' onClick={() => handleRetry(true)}>
            {' '}
            Create{' '}
          </RetryButton>
        </ButtonsWrapper>
      )}
      <RetryNoteModal
        dealerId={'TODO'}
        currentNote={null}
        notesRetryModalOpen={notesRetryModalOpen}
        retry={() => onRetryClick(false)}
        setSentRetries={null}
        setNotesRetryModalOpen={setNotesRetryModalOpen}
      />
    </WarningWrapper>
  );
};

export default NoteWarning;
